import { GET_ALL_PN } from "../actions/productNeed.actions";

const initialState = {};

export default function productNeedReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_PN:
      return action.payload;
    default:
      return state;
  }
}
